<template>
  <div class="empty-state">
    <p class="empty-state__title">
      {{ title }}
    </p>
    <p class="empty-state__subtitle">
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-state {
  height: 100%;
  margin-top: auto;
  margin-bottom: auto;

  &__title {
    font-size: 13px;
    line-height: 20px;
    font-weight: 500;
    margin-bottom: 4px;
    text-align: center;
  }
  &__subtitle {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    text-align: center;
  }
}
</style>
